import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const MERCHANT_PROFILE_ENDPOINT = '/one'
const MERCHANT_GET_CUSTOMERS_ENDPOINT = '/customer?deleted=false'
const MERCHANT_GET_SUPPLIERS_ENDPOINT = '/sc/suppliers'
const BUSINESS_CATEGORIES_ENDPOINT = '/v1.0/categories'
const SYNC_TRANSACTION_ENDPOINT = 'sync-transactions'
const MERCHANT_CUSTOMER_SUPPLIER_TRANSACTION_ENDPOINT = '/new/GetTransactions'
const MERCHANT_CONTACT_ENDPOINT = '/contacts/network-by-merchant-id'
const MERCHANT_HELP_ENDPOINT = '/help'
const GENERATE_USER_STATEMENT_ENDPOINT = '/report/v2/report'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/identity/legacy`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const registerMerchantName = (name: string) => {
  return api.patchRequest(MERCHANT_PROFILE_ENDPOINT, {
    name,
    update_name: true
  })
}

export const getMerchantProfile = () => {
  return api.getRequest(MERCHANT_PROFILE_ENDPOINT, {})
}

export const patchMerchantProfile = (payload: object) => {
  return api.patchRequest(MERCHANT_PROFILE_ENDPOINT, payload)
}

export const getCustomersList = () => {
  return api.getRequest(MERCHANT_GET_CUSTOMERS_ENDPOINT, {})
}

export const getSuppliersList = () => {
  return api.getRequest(MERCHANT_GET_SUPPLIERS_ENDPOINT, {})
}

export const getBusinessCategories = () => {
  return api.getRequest(BUSINESS_CATEGORIES_ENDPOINT, {})
}

export const getCustomerTransactions = ({ id = '', start_time = 0, end_time, orderBy }: any) => {
  return api.postRequest(MERCHANT_CUSTOMER_SUPPLIER_TRANSACTION_ENDPOINT, {
    txn_req: {
      type: 1,
      role: 1,
      account_id: id,
      order_by: orderBy || 3,
      start_time,
      include_start_time: true,
      ...(end_time ? { end_time } : {})
    }
  })
}

export const getSupplierTransactions = ({ id = '', start_time = 0, end_time, orderBy }: any) => {
  return api.postRequest(MERCHANT_CUSTOMER_SUPPLIER_TRANSACTION_ENDPOINT, {
    txn_req: {
      type: 1,
      role: 2,
      account_id: id,
      order_by: orderBy || 3,
      start_time,
      include_start_time: true,
      ...(end_time ? { end_time } : {})
    }
  })
}

export const getContactsFromMerchant = () => {
  return api.getRequest(MERCHANT_CONTACT_ENDPOINT, {})
}

export const getHelpSection = (merchantId: string) => {
  return api.getRequest(`${MERCHANT_HELP_ENDPOINT}?merchant_id=${merchantId}`, {})
}

export const generateTransactionReport = (payload: {
  merchant_id: string
  account_id: string
  start_time?: number
  end_time?: number
  type: number
  lang: string
}) => api.postRequest(GENERATE_USER_STATEMENT_ENDPOINT, payload)

export const editTransaction = (payload: object) => {
  return api.postRequest(SYNC_TRANSACTION_ENDPOINT, payload)
}

export const MerchantApi = {
  registerMerchantName,
  getMerchantProfile,
  patchMerchantProfile,
  getCustomersList,
  getSuppliersList,
  getBusinessCategories,
  getCustomerTransactions,
  getSupplierTransactions,
  getContactsFromMerchant,
  getHelpSection,
  generateTransactionReport,
  editTransaction
}
